'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HtmlWrapper = require('./HtmlWrapper');

var _HtmlWrapper2 = _interopRequireDefault(_HtmlWrapper);

var _SectionHeader = require('./SectionHeader');

var _SectionHeader2 = _interopRequireDefault(_SectionHeader);

var _CareTeamSection = require('./customSections/CareTeamSection');

var _CareTeamSection2 = _interopRequireDefault(_CareTeamSection);

var _ContributorsSection = require('./customSections/ContributorsSection');

var _ContributorsSection2 = _interopRequireDefault(_ContributorsSection);

var _InFulfillmentOfsSection = require('./customSections/InFulfillmentOfsSection');

var _InFulfillmentOfsSection2 = _interopRequireDefault(_InFulfillmentOfsSection);

var _ComponentOfSection = require('./customSections/ComponentOfSection');

var _ComponentOfSection2 = _interopRequireDefault(_ComponentOfSection);

var _ParticipantsSection = require('./customSections/ParticipantsSection');

var _ParticipantsSection2 = _interopRequireDefault(_ParticipantsSection);

var _AuthorizationsSection = require('./customSections/AuthorizationsSection');

var _AuthorizationsSection2 = _interopRequireDefault(_AuthorizationsSection);

var _DocumentationOfsSection = require('./customSections/DocumentationOfsSection');

var _DocumentationOfsSection2 = _interopRequireDefault(_DocumentationOfsSection);

var _NonXmlBodySection = require('./customSections/NonXmlBodySection');

var _NonXmlBodySection2 = _interopRequireDefault(_NonXmlBodySection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CcdSection = function (_Component) {
  _inherits(CcdSection, _Component);

  function CcdSection(props) {
    _classCallCheck(this, CcdSection);

    var _this = _possibleConstructorReturn(this, (CcdSection.__proto__ || Object.getPrototypeOf(CcdSection)).call(this, props));

    _this.scrollTo = _this.scrollTo.bind(_this);
    return _this;
  }

  _createClass(CcdSection, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, prevProps) {
      if (nextProps.shouldScrollTo) {
        //scroll to the section
        this.scrollTo();
        //clear the scroll to flag so we don't infinitely scroll to it.
        this.props.clearScrollToCB();
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo() {
      if (this.refs['scrollToRef']) {
        this.refs['scrollToRef'].scrollIntoView();
      }
    }
  }, {
    key: 'renderCustomSection',
    value: function renderCustomSection(customSectionContents) {
      var code = this.props.code;
      var customSectionRender = null;
      switch (code) {
        case "careTeam":
          customSectionRender = _react2.default.createElement(_CareTeamSection2.default, { performers: customSectionContents.performers });
          break;
        case "contributors":
          customSectionRender = _react2.default.createElement(_ContributorsSection2.default, {
            authors: customSectionContents.authors,
            authenticators: customSectionContents.authenticators,
            legalAuthenticator: customSectionContents.legalAuthenticator,
            dataEnterer: customSectionContents.dataEnterer,
            informants: customSectionContents.informants,
            informationRecipients: customSectionContents.informationRecipients,
            custodian: customSectionContents.custodian,
            officeContacts: customSectionContents.officeContacts
          });
          break;
        case "inFulfillmentOfs":
          customSectionRender = _react2.default.createElement(_InFulfillmentOfsSection2.default, { inFulfillmentOfsArray: customSectionContents });
          break;
        case "componentOf":
          customSectionRender = _react2.default.createElement(_ComponentOfSection2.default, { encompassingEncounters: customSectionContents.encompassingEncounters });
          break;
        case "participants":
          customSectionRender = _react2.default.createElement(_ParticipantsSection2.default, { participants: customSectionContents });
          break;
        case "authorizations":
          customSectionRender = _react2.default.createElement(_AuthorizationsSection2.default, { authorizationsArray: customSectionContents });
          break;
        case "documentationOfs":
          customSectionRender = _react2.default.createElement(_DocumentationOfsSection2.default, { documentationOfsArray: customSectionContents });
          break;
        case "nonXmlBody":
          customSectionRender = _react2.default.createElement(_NonXmlBodySection2.default, { contentString: customSectionContents });
          break;
        default:
          customSectionRender = null;
      }
      return customSectionRender;
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      return _react2.default.createElement(
        'div',
        { className: 'sectionContents dropShadow' },
        this.props.customSectionContents ? this.renderCustomSection(this.props.customSectionContents) : null,
        this.props.sectionContents ? _react2.default.createElement(_HtmlWrapper2.default, { html: this.props.sectionContents }) : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isExpanded = _props.isExpanded,
          sectionHeader = _props.sectionHeader,
          moveUpEnabled = _props.moveUpEnabled,
          moveDownEnabled = _props.moveDownEnabled,
          moveSectionCB = _props.moveSectionCB,
          toggleCollapseCB = _props.toggleCollapseCB;


      return _react2.default.createElement(
        'div',
        { id: "ccdSection" + this.props.id, className: 'ccdSection', ref: 'scrollToRef' },
        _react2.default.createElement(_SectionHeader2.default, {
          title: sectionHeader,
          isExpanded: isExpanded,
          moveUpEnabled: moveUpEnabled,
          moveDownEnabled: moveDownEnabled,
          moveSectionCB: moveSectionCB,
          toggleCollapseCB: toggleCollapseCB,
          id: this.props.id
        }),
        this.props.isExpanded ? this.renderContent() : null
      );
    }
  }]);

  return CcdSection;
}(_react.Component);

CcdSection.propTypes = {
  id: _propTypes2.default.number,
  code: _propTypes2.default.string,
  sectionHeader: _propTypes2.default.string,
  sectionContents: _propTypes2.default.string,
  //TODO Add Subsection
  customSectionContents: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array]),
  isExpanded: _propTypes2.default.bool,
  shouldScrollTo: _propTypes2.default.bool,
  moveUpEnabled: _propTypes2.default.bool,
  moveDownEnabled: _propTypes2.default.bool,
  moveSectionCB: _propTypes2.default.func,
  toggleCollapseCB: _propTypes2.default.func,
  clearScrollToCB: _propTypes2.default.func
};

exports.default = CcdSection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/CcdSection.js
// module id = 1206
// module chunks = 0